import { useJSONFetcher, JSONFetcherOptions } from "@outplayed/json-fetcher";
import { useUGGApiVersions } from "../ugg-api-versions";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { getApiRoot } from "@ugg/shared/api/api-helpers";
import { cleanRunes } from "@ugg/shared/api/data-parser/champions/runes-table";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

import { RunesTable } from "@ugg/shared/interfaces/champions/runes-table.interface";

export function useRunesURL(championId: number, options: { queueType?: string; patch?: string }) {
  const { queueType, patch } = options;
  const { data: version } = useUGGApiVersions({ apiKey: "runes", patch });
  const root = getApiRoot(patch);

  return [`${root}/table/runes`, patch, queueType, championId, `${version}.json`].join("/");
}

export function useChampionRunes(
  championId: number,
  options?: { params?: Record<string, any> } & JSONFetcherOptions<RunesTable, ReturnType<typeof cleanRunes>>,
) {
  const { params = {}, ssr = false, skip = false } = options || {};
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.RUNES_TABLE, params, true);

  const championRunesURL = useRunesURL(championId, validatedQueryParams);
  return useJSONFetcher<RunesTable, ReturnType<typeof cleanRunes>>(championRunesURL, {
    ssr,
    skip,
    onCompleted: (url, json) => cleanRunes(json),
  });
}
